module.exports = __webpack_public_path__ + "img/29204c8.jpg";